module.exports = __webpack_public_path__ + "img/plus.6f16e754.svg";